import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { Layer } from '../..';
import { LayerHotkeyType } from '../../type';

export function useSortLayerHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        const controller = new Layer(framework.identity);

        const getActiveLayerSortInfo = () => {
            const activeLayer = framework.service.frame.getActiveLayer();
            if (!activeLayer) return;
            return controller.getSortData(activeLayer.id);
        };

        framework.service.hotkey.register({
            name: $t((v) => v.Text_MoveUpOneLayer),
            win: 'Ctrl ↑',
            mac: '⌘ ↑',
            key: LayerHotkeyType.SORT_UP,
            processors: [
                {
                    press: ['Ctrl+Up', 'Command+Up'],
                    fn: () => {
                        const res = getActiveLayerSortInfo();
                        if (res && !res.operate.disableUp) {
                            controller.sort(1, res.data);
                        }
                    },
                },
            ],
        });

        framework.service.hotkey.register({
            name: $t((v) => v.Text_MoveDownOneLayer),
            win: 'Ctrl ↓',
            mac: '⌘ ↓',
            key: LayerHotkeyType.SORT_DOWN,
            processors: [
                {
                    press: ['Ctrl+Down', 'Command+Down'],
                    fn: () => {
                        const res = getActiveLayerSortInfo();
                        if (res && !res.operate.disableDown) {
                            controller.sort(-1, res.data);
                        }
                    },
                },
            ],
        });

        framework.service.hotkey.register({
            name: $t((v) => v.Text_Top),
            win: 'Shift Ctrl ↑',
            mac: '⇧ ⌘ ↑',
            key: LayerHotkeyType.SORT_TOP,
            processors: [
                {
                    press: ['Shift+Ctrl+Up', 'Shift+Command+Up'],
                    fn: () => {
                        const res = getActiveLayerSortInfo();
                        if (res && !res.operate.disableUp) {
                            controller.sort(res.cursor.upCount, res.data);
                        }
                    },
                },
            ],
        });

        framework.service.hotkey.register({
            name: $t((v) => v.Text_Bottom),
            win: 'Shift Ctrl ↓',
            mac: '⇧ ⌘ ↓',
            key: LayerHotkeyType.SORT_BOTTOM,
            processors: [
                {
                    press: ['Shift+Ctrl+Down', 'Shift+Command+Down'],
                    fn: () => {
                        const res = getActiveLayerSortInfo();
                        if (res && !res.operate.disableDown) {
                            controller.sort(res.cursor.downCount, res.data);
                        }
                    },
                },
            ],
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps -- register once per mount
    }, []);
}
